import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/hotel-manage-amount',
            name: 'hotel-manage-amount',
            component: () => import(/* webpackChunkName: "page-admin-hotel-manage-components-detail" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "酒店管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "酒店列表"
                                        },
                                        {
                                                  name: "设置附加金额"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
